import { SET_USER, CLEAR_USER, SET_TRANSACTIONS, CLEAR_TRANSACTIONS, RESERVED_PAYMENT_SUCCESS, RESERVED_GIFTCARD_PAYMENT_SUCCESS } from './types';

const initialState = {
  user: null,
  transactions: [],
  reservedBooking: {},
  reservedGiftResult: {},
};

export default function(state = initialState, { type, payload }) {
  switch (type) {
    case SET_USER: {
      return {
        ...state,
        user: payload.user
      };
    }

    case CLEAR_USER: {
      return {
        ...state,
        user: null
      };
    }

    case SET_TRANSACTIONS: {
      return {
        ...state,
        transactions: payload.transactions
      };
    }

    case CLEAR_TRANSACTIONS: {
      return {
        ...state,
        transactions: []
      };
    }

    case RESERVED_PAYMENT_SUCCESS: {
      return {
        ...state,
        reservedBooking: payload.reservedResult
      };
    }

    case RESERVED_GIFTCARD_PAYMENT_SUCCESS: {
      return {
        ...state,
        reservedGiftResult: payload.reservedGiftResult
      };
    }

    default: {
      return state;
    }
  }
}
